<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="
        py-2
        px-2
        text-center
        font-bold
        uppercase
        tracking-wide
        bg-mi-blue-500
        rounded-t-lg
        text-gray-100
        truncate
      "
    >
      {{ header }}
    </div>
    <div>
      <FormulateForm class="input" @submit="register">
        <FormulateInput
          type="text"
          name="username"
          v-model="username"
          validation="required|alphanumeric"
          :wrapper-class="['login-wrapper-class']"
          input-class="bg-gray-100 w-full h-10 px-5 pr-10 rounded-lg text-sm focus:outline-none border-gray-700 border font-opensans mt-4"
          aria-placeholder="Gebruikersnaam"
          placeholder="Gebruikersnaam"
          :validation-messages="{
            required: 'Gebruikersnaam is verplicht',
            alphanumeric:
              'Een gebruikersnaam mag alleen uit letters en cijfers bestaan.',
          }"
        />

        <FormulateInput
          type="email"
          name="email"
          v-model="email"
          validation="required|email"
          :wrapper-class="['login-wrapper-class']"
          aria-placeholder="Email"
          input-class="bg-gray-100 w-full h-10 px-5 pr-10 rounded-lg text-sm focus:outline-none border-gray-700 border font-opensans mt-4"
          placeholder="Email"
          :validation-messages="{
            required: 'Email is verplicht',
            email: 'Dit is geen geldig emailadres.',
          }"
        />

        <FormulateInput
          label="Aanmaken"
          type="submit"
          input-class="btn btn-blue"
        />
      </FormulateForm>
      {{ this.error_msg }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterUserCard",
  data() {
    return {
      username: "",
      email: "",
      error_msg: null,
      header: "Gebruiker toevoegen",
    };
  },
  methods: {
    register: async function () {
      this.error_msg = null;
      let response = await this.$store.dispatch("registerUser", {
        username: this.username,
        email: this.email,
      });
      if ("error" in response) {
        this.error_msg = "Fout bij registreren gebruiker";
      } else {
        this.error_msg =
          "Gebruiker geregistreerd. E-mail naar gebruiker verzonden.";
      }
    },
  },
};
</script>

<style>
.login-wrapper-class {
  @apply block;
}
</style>
